import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { api } from '../api/client.ts';
import { clearAllDrafts } from '../patients/drafts.ts';

/**
 * Ends the session on the server, forgets everything cached (including registration drafts
 * on this device), and returns to sign-in.
 */
export function useSignOut(): () => void {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useCallback(() => {
    void (async () => {
      try {
        await api('POST', '/auth/sign-out');
      } finally {
        queryClient.clear();
        await clearAllDrafts();
        await navigate({ to: '/sign-in', search: { reason: 'signed_out' } });
      }
    })();
  }, [queryClient, navigate]);
}
